(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clemoments-horizon-home"] && !Shopify.designMode) return;
  try {
    
  function initReviewCarousels(scope) {
    scope.querySelectorAll('.cg-reviews').forEach((reviews) => {
      if (reviews.dataset.carouselReady === 'true') return;
      reviews.dataset.carouselReady = 'true';
      const track = reviews.querySelector('[data-review-track]');
      const previous = reviews.querySelector('[data-review-prev]');
      const next = reviews.querySelector('[data-review-next]');
      if (!track || !previous || !next) return;
      const move = (direction) => {
        const card = track.querySelector('.cg-review');
        if (!card) return;
        const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
        track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
    });
  }
  initReviewCarousels(document);
  document.addEventListener('shopify:section:load', (event) => initReviewCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
